import { BigNumber } from '@ethersproject/bignumber'

/*
localStorage.setItem(
  'LIMITS_MOCK',
  JSON.stringify({
    totalValue: '',
    dailyValue: '',
    poolDailyLimit: '',
    poolGlobalLimit: '',
    globalLimit: '',
    userGlobalLimit: '',
    globalNFCSLimit: '',
    totalOutStanding: '',
    nfcsTotalOutstanding: '',
    userTotalOutstanding: '',
  }),
)

localStorage.removeItem('LIMITS_MOCK')
*/

const LS_KEY = 'LIMITS_MOCK'

const MOCKABLE_KEYS = [
  'totalValue',
  'dailyValue',
  'poolDailyLimit',
  'poolGlobalLimit',
  'globalLimit',
  'userGlobalLimit',
  'globalNFCSLimit',
  'totalOutStanding',
  'nfcsTotalOutstanding',
  'userTotalOutstanding',
] as const

type MockMap = {
  [key in typeof MOCKABLE_KEYS[number]]?: BigNumber
}

export function getLimitsMock() {
  try {
    const loaded = localStorage.getItem(LS_KEY)
    if (!loaded) return
    const parsed = JSON.parse(loaded)
    return MOCKABLE_KEYS.reduce<MockMap>((res, key) => {
      try {
        const val = BigNumber.from(parsed[key])
        return {
          ...res,
          [key]: val,
        }
      } catch (err) {
        return res
      }
    }, {})
  } catch (err) {
    return
  }
}
